import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

export default function PasswordStrength({ password }) {
  const { strength, label, level } = useMemo(() => {
    if (!password) {
      return { strength: 0, label: 'Minimum 8 caractères', level: 'none' };
    }

    let score = 0;
    const checks = {
      length: password.length >= 8,
      lowercase: /[a-z]/.test(password),
      uppercase: /[A-Z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[^a-zA-Z0-9]/.test(password),
    };

    if (checks.length) score++;
    if (checks.lowercase && checks.uppercase) score++;
    if (checks.number) score++;
    if (checks.special) score++;

    const levels = [
      { strength: 0, label: 'Très faible', level: 'weak' },
      { strength: 1, label: 'Faible', level: 'weak' },
      { strength: 2, label: 'Moyen', level: 'medium' },
      { strength: 3, label: 'Fort', level: 'strong' },
      { strength: 4, label: 'Excellent', level: 'strong' },
    ];

    return levels[score];
  }, [password]);

  return (
    <div className="password-strength">
      <div className="strength-bars">
        {[1, 2, 3, 4].map((bar) => (
          <div
            key={bar}
            className={`strength-bar ${bar <= strength ? `strength-bar--active strength-bar--${level}` : ''}`}
          />
        ))}
      </div>
      <div className="strength-text">{label}</div>
    </div>
  );
}

PasswordStrength.propTypes = {
  password: PropTypes.string.isRequired,
};
